Controller.$inject = ['$element', '$scope'];

function Controller($element, $scope) {
    const self = this;
    let draggingEle = null;
    let placeholder = null;
    let isDraggingStarted = false;
    let x = 0;
    let y = 0;
    let width = 0;

    let ele = $element[0];

    function isInputElement(target) {
        return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA';
    }

    function mouseMoveHandler(e) {
        if (!isDraggingStarted) {
            isDraggingStarted = true;
        }

        const container = draggingEle.parentNode;
        if (!container) return;

        const containerRect = container.getBoundingClientRect();
        const elementRect = draggingEle.getBoundingClientRect();

        if (!placeholder) {
            placeholder = angular.element('<div class="dnd-placeholder"></div>');
            placeholder.css({
                height: `${elementRect.height}px`,
                width: `${elementRect.width}px`,
            });
            draggingEle.parentNode.insertBefore(placeholder[0], draggingEle.nextSibling);
        }

        // Calculate new top and left positions
        let newY = e.clientY - y;
        let newX = e.clientX - x;

        // Constrain vertical movement within container
        if (newY < containerRect.top) {
            newY = containerRect.top;
        } else if (newY + elementRect.height > containerRect.bottom) {
            newY = containerRect.bottom - elementRect.height;
        }

        // Constrain horizontal movement within container
        if (newX < containerRect.left) {
            newX = containerRect.left;
        } else if (newX + elementRect.width > containerRect.right) {
            newX = containerRect.right - elementRect.width;
        }

        draggingEle.style.position = 'fixed';
        draggingEle.style.top = `${newY}px`;
        draggingEle.style.left = `${newX}px`;
        draggingEle.style.width = width + 'px';

        const siblings = Array.from(draggingEle.parentNode.children).filter(
            (child) => child !== draggingEle && child !== placeholder[0]
        );

        for (let sibling of siblings) {
            const rect = sibling.getBoundingClientRect();
            if (e.clientY < rect.top + rect.height / 2) {
                sibling.parentNode.insertBefore(placeholder[0], sibling);
                break;
            } else {
                sibling.parentNode.appendChild(placeholder[0]);
            }
        }
    }

    function mouseUpHandler() {
        if (placeholder && placeholder[0] && draggingEle) {

            const parent = placeholder[0] && placeholder[0].parentNode;
            if (parent) {
                let newIndex = parent && Array.from(parent.children).indexOf(placeholder[0]);

                newIndex = newIndex > self.index ? newIndex - 1 : newIndex;
                if (newIndex !== self.index) {
                    self.onDragEnd({$event: {oldIndex: self.index, newIndex}});
                }
            }
            placeholder[0].remove();
            placeholder.remove();
            draggingEle.style.removeProperty('position');
            draggingEle.style.removeProperty('top');
            draggingEle = null;
            isDraggingStarted = false;
        }

        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
    }

    function mouseDownHandler(e) {
        if (isInputElement(e.target) || self.preventDragging) return;

        draggingEle = $element[0];
        draggingEle.style.cursor = 'grabbing';

        const rect = draggingEle.getBoundingClientRect();
        width = rect.width;
        x = e.clientX - rect.left;
        y = e.clientY - rect.top;
        isDraggingStarted = false;

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);

        self.onDragStart({$event: {oldIndex: self.index}});
    }

    self.$postLink = () => {
        ele = $element[0];
        ele.addEventListener('mousedown', mouseDownHandler);
    };

    $scope.$on('$destroy', () => {
        ele.removeEventListener('mousedown', mouseDownHandler);
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
    });
}

export function HuiDraggableItem() {
    return {
        restrict: 'EA',
        replace: true,
        scope: true,
        bindToController: {
            index: '<',
            onDragStart: '&',
            onDragEnd: '&',
            preventDragging: '<?',
            itemVariant: '@',
            active: '<?'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            action: '?huiDraggableAction'
        },
        template: `
            <div class="hui hui-draggable-item"
                 ng-class="[{'disabled': $huiCtrl.preventDragging, 'active': $huiCtrl.active},
                          (!$huiCtrl.preventDragging && $huiCtrl.itemVariant) ? $huiCtrl.itemVariant : '']">
                <span class="grip-icon">
                    <i ng-if="!$huiCtrl.preventDragging && !$huiCtrl.active" class="fa fa-grip-vertical"></i>
                </span>
                <div class="draggable-content-container">
                    <div class="hui-draggable-content" ng-transclude></div>
                    <div class="hui-draggable-content-action" ng-transclude="action"></div>
                </div>
            </div>
        `,
    };
}
